export const RADIO_BUTTON_SELECTORS = {
	NORMAL: '#rb_normal',
	SELECTED: '#rb_selected',
	LABEL: '#rb_label'
};